var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Checkbox, Tooltip } from "../../../../Atoms";
var CheckboxCell = function (_a) {
    var columnName = _a.columnName, checked = _a.checked, tooltip = _a.tooltip, secondaryTooltip = _a.secondaryTooltip, handleChange = _a.handleChange, id = _a.id, Icon = _a.Icon, CheckedIcon = _a.CheckedIcon;
    var iconProps = Icon && CheckedIcon ? { icon: _jsx(Icon, {}), checkedIcon: _jsx(CheckedIcon, {}) } : {};
    return (_jsx(Tooltip, __assign({ "data-testid": "tooltip-".concat(columnName, "-").concat(id), title: checked ? secondaryTooltip : tooltip }, { children: _jsx("span", { children: _jsx(Checkbox, __assign({ name: "checkbox-".concat(columnName, "-").concat(id), id: "checkbox-".concat(columnName, "-").concat(id), checked: checked, onChange: handleChange }, iconProps)) }) })));
};
export default CheckboxCell;
